export default {
    isLogin: localStorage.getItem('isLogin') ? localStorage.getItem('isLogin') : false,
    topChatUserInfo: JSON.parse(localStorage.getItem('topChatUserInfo')) || null,
    token: localStorage.getItem('topChatToken') || '',
    chatType: 'chat',  // 模版类型 test 测试 chat 聊天
    appTemplate: null,  // app模版数据(用于测试)
    templateAppList: {  // 模版列表
        code:0,
        list:[]
    }, 
    // ai绘画模版
    templateAiDraw:{
        code:0,
        list:[]
    },  
    myTemplateList:{    // 我的应用
        isMore:true,
        code:0,
        list:[]
    },    // 我的模版列表
    chatTemplate:null,    // 聊天模版
    // 聊天配置
    chatConfig: JSON.parse(localStorage.getItem('chatConfig')) || {
        recordNum: 6, // 上下文数量
        temperature: 1, // 随机性
        top_p: 1, // 话题新鲜度
        maxTokens: 2048, // 最大Token数
        sendKeyboard:1,// 发送键
    },
    coinProductsList:[],    // T币充值列表
    productsList:[],        // 套餐列表
    demoQuestionsList:[],   // 示例问题列表
    coinRecordDetailList:[],  // 消耗明细
    chatList:{     // 聊天消息
        code:0,
        list:[]
    },
    styleList:[], // ai绘画样式类型
    tasksList:[], // 我的任务列表
    db:null
}